import PropTypes from "prop-types";
import styles from "./utility-area.module.less";
import { DateHelper, PrimaryButton, PrimaryButtonLink } from "@parksandresorts/core";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const UtilityArea = (props) => {
  const { onClickButton, buttonLabel, buttonLink, visible, className } = props;
  const hasTextContent = props.location || props.nextShowTime;
  return visible ? (
    <div
      className={[
        styles.utilityOuterWrapper,
        hasTextContent ? styles.withTextContent : "",
        className,
        props.visible ? styles.visible : "",
      ].join(" ")}
    >
      {hasTextContent && (
        <div className={["block--padded", styles.utilityWrapper].join(" ")}>
          {props.nextShowTime && DateHelper.isDateValid(props.nextShowTime) && (
            <span className={[styles.utilityShowText, "body-s"].join(" ")}>
              <span className={[props.icon ? props.icon : "icon-calendar", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{DateHelper.toStringDDMonth(props.nextShowTime)}</span>
            </span>
          )}
          {props.nextShowTime && DateHelper.isDateValid(props.nextShowTime) && (
            <span className={[styles.utilityShowText, "body-s"].join(" ")}>
              <span className={[props.icon ? props.icon : "icon-time", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{DateHelper.toStringTimeHHMM(props.nextShowTime)}</span>
            </span>
          )}
          {props.location && (
            <span className={[styles.utilityShowText, "body-s"].join(" ")}>
              <span className={[props.icon ? props.icon : "icon-location", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{props.location}</span>
            </span>
          )}
        </div>
      )}
      {visible &&
        (buttonLink || typeof onClickButton === "function") &&
        (buttonLink ? (
          <PrimaryButtonLink
            url={buttonLink}
            className={styles.buyBtn}
            label={buttonLabel ? buttonLabel : SiteConfigurationStore.getLabel("BUY_NOW")}
            openInNewTab={true}
          />
        ) : (
          <PrimaryButton
            onClick={onClickButton}
            className={styles.buyBtn}
            label={buttonLabel ? buttonLabel : SiteConfigurationStore.getLabel("BUY_NOW")}
            openInNewTab={true}
          />
        ))}
    </div>
  ) : null;
};

UtilityArea.propTypes = {
  visible: PropTypes.bool,
  onClickButton: PropTypes.func,
  buttonLink: PropTypes.string,
  buttonLabel: PropTypes.string,
  className: PropTypes.string,
};

export default UtilityArea;
